<template>
  <div
    ref="editAreaRef"
    :style="pageStyle"
    @contextmenu.prevent.stop="showContextMenu($event)"
    @click.stop="selectItem"
  >
    <!-- 表单 -->
    <template v-if="projectStore.isFormPage">
      <el-form
        label-position="top"
        :model="globalForm"
        :rules="globalRules"
        label-width="120px"
        :style="{ height: '100%' }"
      >
        <WidgetLayout
          :key="cnpKey"
          v-model:widget-data-list="widgetData.list"
          style="background: #fff"
          :style="formPageStyle"
        />
      </el-form>
    </template>

    <!-- 非表单 -->
    <template v-else>
      <WidgetLayout :key="cnpKey" v-model:widget-data-list="widgetData.list" />
    </template>

    <AuxiliaryLineVue
      :draging="layoutStore.auxiliaryLineShow"
      :top="layoutStore.auxiliaryLineTop"
    />
    <WidgetRightClickMenuVue
      v-model:show-menu="rightClickMenuInfo.showMenu"
      :position="rightClickMenuInfo.position"
      :menus="rightClickMenuInfo.contextMenus"
      :widget="rightClickMenuInfo.triggerWiget"
      @trigger-item="triggerItem"
    />
    <JudgeTableBindFormDialog ref="judgeTableBindFormDialogRef"></JudgeTableBindFormDialog>
  </div>
</template>
<script lang="ts">
  export default {
    name: 'EditForm'
  }
</script>
<script setup lang="ts">
  import { findIndex, debounce, cloneDeep } from 'lodash-es'
  import {
    useCopyAndPaste as UseCopyAndPaste,
    useLayout,
    havePermission,
    EMITTER_NAME,
    ROUTE_PATH_CONSTANT,
    transOption2TypeObj,
    updatePageOptionByNewOption,
    JudgeTableBindFormDialog,
    upgradePageSchema
  } from '@haohan/clw-platform-public'
  import type { Position } from '@haohan/clw-platform-public'
  import WidgetRightClickMenuVue from './WidgetRightClickMenu.vue'
  import { TriggerRightContextMenu, WidgetDataInfo } from './index'
  import {
    emitter,
    widgetEvent,
    getWigetEventAndComParamInfo,
    getRunInEvent,
    getKey,
    resetDisposableCommonParam
  } from '@haohan/clw-utils'
  import AuxiliaryLineVue from './AuxiliaryLine.vue'
  import { useProject, useWidget, useEvent, useGlobalStore } from '@haohan/clw-store'
  import { getMenu, updatePage, getAllPageByProject, saveMenus } from '@haohan/clw-api'
  import { onKeyStroke } from '@vueuse/core'
  import { useLoading, usePermissionHook } from '@haohan/clw-hooks'
  import dayjs from 'dayjs'
  import { reactive, ref, computed, watch, watchEffect, onMounted, onUnmounted, provide } from 'vue'
  import { useRouter } from 'vue-router'
  import { ElLoading, ElMessage, ElForm } from 'element-plus'
  import { WidgetLayout } from '@haohan/clw-components'
  import { useEventCenter } from '@haohan/clw-event'

  const props = withDefaults(
    defineProps<{
      outControl?: boolean // 将保存操作交由外部控制外部控制，目前是给工作流使用
    }>(),
    {
      outControl: false
    }
  )
  const router = useRouter()
  const widgetStore = useWidget()
  const eventStore = useEvent()
  const projectStore = useProject()
  const layoutStore = useLayout()
  const globalStore = useGlobalStore()
  const { tree2Array4CompFn } = usePermissionHook()
  const { initInfo, clearEventListener, rebuildEventInfoByRemoveWidget } = useEventCenter()

  const widgetData = reactive<WidgetDataInfo>({
    list: []
  })
  // 备份接口返回的组件信息
  let widgetListBak = []
  // 使用该方法强制重新渲染组件
  const cnpKey = ref(getKey())
  /**
   * 加载页面组件信息
   */
  // 当前页面得组件信息
  onMounted(() => {
    if (!projectStore?.currentProject?.id) {
      router.push({ path: ROUTE_PATH_CONSTANT.DashBoard })
    }

    globalStore.changeEdieModel(true)
    addShortcutFun()
    document.addEventListener('keydown', ctrlSListener)
    // TODO: loadAllPageDialogSendEvent permission里面已经存在了，添加交互时需要怎么处理？
    loadAllPageRunInSendEvent()
    emitter.on(EMITTER_NAME.ReloadWidget, reloadWidget)
    emitter.on(EMITTER_NAME.RemoveWidget, handleRemoveWidget)
    emitter.on(EMITTER_NAME.UpdatePageOptionByNewOption, exeUpdatePageOptionByNewOption)

    // 保存组件
    emitter.on(EMITTER_NAME.SaveComponentsGlobal, saveComponents)

    // 同步关联数据
    emitter.on(EMITTER_NAME.SyncRelatedData, syncRelatedData)
  })
  onUnmounted(() => {
    removeShortcutFun()
    document.removeEventListener('keydown', ctrlSListener)
    emitter.off(EMITTER_NAME.ReloadWidget, reloadWidget)
    emitter.off(EMITTER_NAME.RemoveWidget, handleRemoveWidget)
    emitter.off(EMITTER_NAME.UpdatePageOptionByNewOption, exeUpdatePageOptionByNewOption)

    emitter.off(EMITTER_NAME.SaveComponentsGlobal)

    // 同步关联数据
    emitter.off(EMITTER_NAME.SyncRelatedData, syncRelatedData)
  })
  const addShortcutFun = () => {
    // emitter.on('editPage-reloadWidgt', loadMenuInfo)
    emitter.on(EMITTER_NAME.EditPageCopy, useCopyAndPaste.copyWidgetStoreItem)
    emitter.on(EMITTER_NAME.EditPagePaste, useCopyAndPaste.pasteItem)
    if (!props.outControl) {
      emitter.on(EMITTER_NAME.SaveComponentsGlobal, saveComponents)
    }

    emitter.on(EMITTER_NAME.EditPageHistory, changeHistory)
    emitter.on(EMITTER_NAME.EditPageForward, onForward)
    emitter.on(EMITTER_NAME.EditPageForward, onBackward)

    emitter.on(EMITTER_NAME.EditPageWidgetLock, compLock)
    emitter.on(EMITTER_NAME.EditPageWidgetUnLock, compUnlock)
  }
  const removeShortcutFun = () => {
    // emitter.off('editPage-reloadWidgt', loadMenuInfo)
    emitter.off(EMITTER_NAME.EditPageCopy, useCopyAndPaste.copyWidgetStoreItem)
    emitter.off(EMITTER_NAME.EditPagePaste, useCopyAndPaste.pasteItem)
    if (!props.outControl) {
      emitter.off(EMITTER_NAME.SaveComponentsGlobal, saveComponents)
    }

    emitter.off(EMITTER_NAME.EditPageHistory, changeHistory)
    emitter.off(EMITTER_NAME.EditPageForward, onForward)
    emitter.off(EMITTER_NAME.EditPageForward, onBackward)

    emitter.off(EMITTER_NAME.EditPageWidgetLock, compLock)
    emitter.off(EMITTER_NAME.EditPageWidgetUnLock, compUnlock)
  }
  /**
   * 保存页面组件信息
   * @param e 按键事件
   */
  const ctrlSListener = (e: any) => {
    if (e.keyCode === 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
      e.preventDefault()
      saveComponents()
    }
  }
  /**
   * 重新加载组件信息
   */
  const loadMenuInfo = () => {
    // 重置 前进后退
    widgetStore.initUndoList()
    // // 重置 历史
    widgetStore.initHistory()

    // // TODO: 判断是否更改
    if (projectStore?.currentProject?.id && projectStore?.currentPage?.id) {
      getMenu(projectStore.currentProject.id, projectStore.currentPage.id).then((res) => {
        console.log('[ res ]-31', res)
        // 去除选中组件
        widgetStore.deleteSelectWidget()
        const _widgetDataList = res?.data?.page?.components || []
        if (globalStore.edieModel) {
          console.time('====>更新开始<=====')
          upgradePageSchema(_widgetDataList)
          console.timeEnd('====>更新开始<=====')
        }
        initPageInfo(_widgetDataList, projectStore.currentPage.id)
        console.log('loadMenuInfo', cloneDeep(_widgetDataList))
        widgetData.list = _widgetDataList
        widgetStore.changeWidgetDataList(_widgetDataList)
        widgetStore.changeWidgetDataListBak(_widgetDataList)
        widgetListBak = cloneDeep(_widgetDataList)
        cnpKey.value = getKey()
      })
    }
  }
  const initPageInfo = (widgetList: Widget[], currentPageId: string) => {
    // 清楚页面参数集合
    eventStore.clearPageWidgetParam()
    // 获得组件集合中得事件和公共参数集合
    const pageInfo = getWigetEventAndComParamInfo(widgetList, currentPageId)
    initInfo(pageInfo)
    console.log('[ pageInfo ]-85', pageInfo, currentPageId)
    // 初始化线程池
    // eventStore.initMutualPoolBySendEvents(pageInfo.sendFilters)
    // 记录组件交互和公共参数信息
    eventStore.changePageInfo(pageInfo)
    eventStore.changeReceiveEvents(pageInfo.receiveFilters)
    eventStore.changeSendEvents(pageInfo.sendFilters)
  }
  const reloadWidget = () => {
    initPageInfo(widgetData.list, projectStore.currentPage.id)
    // 清空所有得监听事件
    // widgetEvent.all.clear()
    cnpKey.value = getKey()
  }
  onUnmounted(() => {
    // 清空所有得监听事件
    // widgetEvent.all.clear()
    clearEventListener()
  })
  const loadAllPageRunInSendEvent = () => {
    if (!projectStore.currentProject.id) {
      return
    }
    getAllPageByProject(projectStore.currentProject.id).then((response: any) => {
      const runInEvents: WidgetEvent[] = []
      const pages = response.data.data
      pages.forEach((page: any) => {
        getRunInEvent(page.components, runInEvents)
      })
      // 更新事件
      eventStore.changeAllPageRunInEvents(runInEvents)
    })
  }
  // 左侧页面切换, 展现弹窗, 点击弹窗 '保存' 按钮触发
  watch(
    () => projectStore.savedDialogSubmited,
    (val, newVal) => {
      if (val) {
        saveComponents()
      }
    },
    { deep: true }
  )

  // 全局 loading
  const globalLoading = useLoading({ text: '正在保存...' })

  //保存页面配置
  function savePageOption() {
    // 判断权限
    if (!havePermission('ProjectPageManager')) {
      return
    }
    // 保存历史
    widgetStore.saveHistory(dayjs().format('YYYY-MM-DD HH:mm:ss'), widgetData.list)

    globalLoading.show()
    const tableIdsSet = new Set<String>()
    // 更新页面组件、数据集不包括页面属性
    const permissionComp = tree2Array4CompFn(cloneDeep(widgetData.list))
    const permissions = permissionComp.map((comp) => {
      const { key, title, type, formProp } = comp
      if (type !== 'HHTable') {
        return {
          name: key,
          title: title,
          type: ['可操作']
        }
      }
      return {
        name: key,
        title: title,
        type: formProp?.customActions?.map((action: any) => action.label).concat(['可操作'])
      }
    })
    // console.log('permission', permissions)
    updatePage(projectStore.currentProject.id, {
      id: projectStore.currentPage.id,
      components: widgetData.list,
      datasetIds: [...tableIdsSet],
      permissions
    })
      .then(() => {
        ElMessage.success({
          message: '保存成功',
          duration: 1000
        })
        widgetListBak = cloneDeep(widgetData.list)
        // 保存备份
        widgetStore.changeWidgetDataListBak(cloneDeep(widgetData.list))
      })
      .finally(() => {
        globalLoading.close()
        // 触发 LeftMenuTree.vue 的 nodeClick()
        if (projectStore.savedDialogSubmited) {
          projectStore.updateSavedDialogSubmitedApiDone(true)
        }
        // 重置
        projectStore.updateSavedDialogSubmited(false)
      })

    // 表单页面需要保存当前页面属性
    if (projectStore.currentPage?.variables?.pageType === 'form') {
      saveMenus(
        projectStore.currentProject.id,
        projectStore.currentModule.id,
        cloneDeep(projectStore.currentPage)
      ).then(() => {
        emitter.emit('reload-p')
      })
    }
  }

  const saveComponents = () => {
    const flag = judgeTableBindFormDialogRef.value.judgeTableBindForm(
      widgetData.list,
      savePageOption
    )
    if (flag) {
      throw new Error('表单页面需要绑定表单')
    } else {
      savePageOption()
    }
  }
  /**
   * 递归设置当前页面使用到得数据表信息
   * @param widgetData 页面信息
   * @param tableIdsSet 使用到得数据表ID
   */
  // const setTableId = (widgetData: WidgetPageInfo, tableIdsSet: Set<String>) => {
  //   widgetData.list.forEach((cp) => {
  //     if (cp.attributes && cp.attributes.length > 0) {
  //       // 获得TableId
  //       const tableIdAttr = find(cp.attributes, (a) => a.name === 'tableId')
  //       if (tableIdAttr && tableIdAttr.value.trim() !== '') {
  //         tableIdsSet.add(tableIdAttr.value)
  //       }
  //     }
  //     if (cp.children && cp.children.length > 0) {
  //       cp.children.forEach((c) => {
  //         setTableId(c, tableIdsSet)
  //       })
  //     }
  //   })
  // }
  // watchEffect如果里面是调用方法，则该方法必须在watchEffect声明前已声明

  //判断是否绑定form表单弹窗实例
  const judgeTableBindFormDialogRef = ref<any>()

  watchEffect(() => {
    loadMenuInfo()
  })

  watch(
    () => widgetData.list,
    (val) => {
      if (projectStore.isFormPage) {
        // 更新表单
        projectStore.updateCurrentFormByWidgetList(widgetData.list)
        // 更新 rules
        projectStore.updateCurrentFormRulesByWidgetList(widgetData.list)
      }

      // 添加记录, 用于 前进/后退
      if (!widgetStore.undoLocked) {
        widgetStore.addUndoItem(widgetData.list)
      }
      widgetStore.changeWidgetDataList(widgetData.list)
      // 更新eventStore页面信息
      const pageInfo = getWigetEventAndComParamInfo(widgetData.list, projectStore.currentPage.id)
      eventStore.changePageInfo(pageInfo)
    },
    { deep: true }
  )

  // 表单和 rules
  const globalForm = computed(() => projectStore.currentForm)
  const globalRules = computed(() => projectStore.currentFormRulesParsed)

  // 复制粘贴功能
  const useCopyAndPaste = UseCopyAndPaste(widgetData)
  /**
   * 右键功能处理
   */
  const defaultContextMenus: RightClickMenuItem[] = [
    {
      label: '刷新'
    },
    {
      label: '粘贴(Ctrl+V)'
    }
  ]
  const rightClickMenuInfo = reactive<{
    widgetList: Widget[]
    triggerWiget: Widget
    showMenu: boolean
    contextMenus: RightClickMenuItem[]
    position: Position
  }>({
    widgetList: [],
    triggerWiget: { type: 'Blank' },
    showMenu: false,
    contextMenus: [],
    position: {
      top: 0,
      left: 0
    }
  })
  // 选中处理
  const selectItem = (): void => {
    widgetStore.changeSelectWidget({ type: 'Blank' })
  }
  const showContextMenu = (event: MouseEvent): void => {
    // 锁定状态不显示右键功能
    if (globalStore.pageLock) {
      return
    }
    console.log('showContextMenu', event)
    triggerRightContextMenu(event, defaultContextMenus, [], { type: 'Blank' })
  }
  // 触发右键菜单功能项
  const triggerItem = (item: RightClickMenuItem): void => {
    console.log('[ item ]-841', item)
    if (item.label.includes('粘贴')) {
      useCopyAndPaste.pasteItem()
    } else if (item.label === '刷新') {
      loadMenuInfo()
    } else if (item.label === '选中') {
      widgetStore.changeSelectWidget(rightClickMenuInfo.triggerWiget)
    } else if (item.label.includes('复制')) {
      useCopyAndPaste.copyItem(rightClickMenuInfo.triggerWiget)
    } else if (item.label.includes('删除')) {
      onDeleteItem()
    }
  }
  const onDeleteItem = (): void => {
    // 查找需要删除得元素
    const index = findIndex(
      rightClickMenuInfo.widgetList,
      (e) => e.key === rightClickMenuInfo.triggerWiget.key
    )
    const deleteWidget = rightClickMenuInfo.widgetList[index]
    rightClickMenuInfo.widgetList.splice(index, 1)
    if (widgetStore.selectWidget.key === rightClickMenuInfo.triggerWiget.key) {
      widgetStore.deleteSelectWidget()
    }
    // 删除对应组件
    widgetStore.deleteSelectWidgetFromWidgetDataList(deleteWidget)
    // 重建交互中心
    handleRemoveWidget(deleteWidget)
    // TODO: 表单的处理
    // 重新加载
    // reloadWidget()
  }
  // 提供右键菜单触发方法，供子组件使用
  const triggerRightContextMenu: TriggerRightContextMenu = (
    event: MouseEvent,
    contextMenus: RightClickMenuItem[],
    widgetList: Widget[],
    triggerWiget: Widget
  ) => {
    rightClickMenuInfo.widgetList = widgetList
    rightClickMenuInfo.triggerWiget = triggerWiget
    rightClickMenuInfo.showMenu = true
    rightClickMenuInfo.position.left = event.clientX
    rightClickMenuInfo.position.top = event.clientY
    rightClickMenuInfo.contextMenus = contextMenus
  }
  provide<TriggerRightContextMenu>('triggerRightContextMenu', triggerRightContextMenu)
  const exeUpdatePageOptionByNewOption = () => {
    const loading = ElLoading.service({
      lock: true,
      text: '正在更新,请稍后....',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    const optionObj = transOption2TypeObj()
    console.log('old widgetData.list', widgetData.list)
    updatePageOptionByNewOption(widgetData.list)
    console.log('new widgetData.list', widgetData.list)
    loading.close()
  }

  // 监听键盘删除, 删除选中组件
  const editAreaRef = ref()
  onKeyStroke(
    ['Delete'],
    (e) => {
      // console.log('触发键盘删除事件 ====', '选中的组件 id ===', widgetStore.selectWidget.key)
      const target = e.target as HTMLElement
      if (target.tagName === 'BODY' || target.closest('#preview .view-box')) {
        e.preventDefault()
        if (widgetStore.selectWidget.key) {
          widgetStore.deleteSelectWidgetFromWidgetDataList()
        } else {
          ElMessage.warning('未选中需要删除的组件')
        }
      }
    },
    { target: editAreaRef.value }
  )
  // ctrl + z 撤销
  onKeyStroke(
    ['z', 'Z'],
    (e) => {
      // console.log('撤销', e)
      if (e.ctrlKey) {
        onBackward()
      }
    },
    { eventName: 'keydown', target: editAreaRef.value }
  )

  // 选择某个历史保存记录
  const changeHistoryOrigin = () => {
    const histroy = widgetStore.historyMap[widgetStore.currentHistoryKey]
    if (histroy) {
      widgetData.list = JSON.parse(JSON.stringify(histroy))
    }
  }
  const changeHistory = debounce(changeHistoryOrigin, 200)

  // 前进
  const onForward = () => {
    widgetStore.lockUndoTemporary()
    widgetData.list = JSON.parse(JSON.stringify(widgetStore.onUndoForward()))
  }
  // 后退
  const onBackward = () => {
    widgetStore.lockUndoTemporary()
    widgetData.list = JSON.parse(JSON.stringify(widgetStore.onUndoBackward()))
  }

  function compLock() {
    widgetStore.updateWidgetProp('isLock', true)
  }
  function compUnlock() {
    widgetStore.updateWidgetProp('isLock', false)
  }

  // 表单页面的 padding
  const formPageStyle = computed(() => {
    const styleProp = projectStore?.currentPage?.variables?.formAttribute?.styleProp
    if (styleProp) {
      return Object.keys(styleProp)
        .map((padding) => {
          return `${padding}:${styleProp[padding]}px`
        })
        .join(';')
    }
    return {}
  })

  const pageStyle = computed(() => {
    const bgColor = projectStore?.currentPage?.variables?.bgColor
    return bgColor ? { backgroundColor: bgColor, height: '100%' } : { height: '100%' }
  })

  const hasPageId = computed(() => projectStore?.currentPage?.id)
  /**
   * 供外部使用
   * 获得当前组件信息
   */
  const getWidgetListByType = (type: 'current' | 'bak') => {
    return type === 'bak' ? widgetListBak : widgetData.list
  }

  defineExpose({ saveComponents, getWidgetListByType })
  /**
   * 同步关联数据，只针对面板
   * @param widget 当前组件
   */
  const syncRelatedData = (widget: Widget) => {
    // 获取发送事件ID
    const sendEvent = widget.events.filter((a: WidgetEvent) => a.eventType === 'send')
    sendEvent.forEach((event: WidgetEvent) => {
      // 获取绑定该事件并且为面板/标签页的组件
      const bindWidgets = widgetData.list.filter((wd: Widget) => {
        return (
          wd.type === 'HHTabPaneWidget' &&
          wd.events.filter(
            (b: WidgetEvent) => b.eventType === 'receive' && b.receiveEventKey === event.key
          ).length > 0
        )
      })
      bindWidgets.forEach((bw: Widget) => {
        // 只覆盖部分值，避免把面板里的组件覆盖
        bw.dataProp.defaultData.forEach((v: any, index: number) => {
          v.label = widget.dataProp.defaultData[index].label
          v.value = widget.dataProp.defaultData[index].value
          v.value2 = widget.dataProp.defaultData[index].value2
        })
      })
    })
    ElMessage.success('同步关联数据成功')
  }
  // 处理删除组件
  const handleRemoveWidget = (widget: Widget) => {
    if (projectStore.isFormPage) {
      // 更新表单
      projectStore.updateCurrentFormByWidgetList(widgetStore.widgetDataList)
      // 更新 rules
      projectStore.updateCurrentFormRulesByWidgetList(widgetStore.widgetDataList)
    }
    rebuildEventInfoByRemoveWidget(widget)
  }
  // 处理一次性全局变量
  onBeforeUnmount(() => {
    // 销毁全局变量
    resetDisposableCommonParam(eventStore.pageInfo.comParam)
  })
</script>
<style lang="scss" scoped>
  .history-select {
    :deep(.el-input__inner) {
      background: transparent !important;
    }
  }
</style>
